import { FC } from 'react';
import { useAtomValue } from 'jotai';
import { $CurrentAvailableArticleOrNull } from '@article/shared/atoms/current-article';
import { $Locale } from '@lemon8/web-app-shared/atom';
// import { Region, RegionHrefLangMap } from '@lemon8/web-app-shared/i18n';
// import { ArticleDetailUtil } from 'shared/models';

export const ArticleCanonical: FC = () => {
  const article = useAtomValue($CurrentAvailableArticleOrNull);
  // const { region } = useAtomValue($Locale);

  if (!article) {
    return null;
  }

  const canonicalPathname = `https://www.lemon8-app.com/${article.author.linkName}/${article.groupId}`;

  // const { translatedRegions = [] } = article;

  // visit translated version
  // const isTranslatedVersion = ArticleDetailUtil.isTranslatedArticleToShow(article, region);

  // const hasTranslatedVersion = ArticleDetailUtil.hasTranslatedVersion(article);

  // const alternateRegions = [...translatedRegions, article.articleRegion];

  return (
    <>
      <link rel="canonical" href={`${canonicalPathname}?region=${article.articleRegion}`} />
      {/* {hasTranslatedVersion && (
        <>
          <link rel="alternate" hrefLang="x-default" href={`${canonicalPathname}?region=${article.articleRegion}`} />
          {alternateRegions.map((alternateRegion) => (
            <link
              rel="alternate"
              key={alternateRegion}
              hrefLang={RegionHrefLangMap[alternateRegion as Region]}
              href={`${canonicalPathname}?region=${alternateRegion}`}
            />
          ))}
        </>
      )} */}
    </>
  );
};
